import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SettingsService } from 'src/app/rest_services/settings.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {
  loading_tab_details:boolean=true;
  uuid:any;
  role:any=null;comp:any=null;
  mobile:boolean=false;medium:boolean=false;
  token:any = '';
  constructor(
    private customersService :CustomersService,
    private route: ActivatedRoute,
    private router: Router,
    private settingsService:SettingsService,
    private msSector:MsSectorService, 
    private location : Location
  ) { }
  previousUrl:any;
  id:any;
  ngOnInit(): void {
    this.getConfig();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];
      this.id= this.route.snapshot.paramMap.get('cr')
      setTimeout(()=>{
        if(from=="show"){
          (<any>$('.nav-pills a[href="#border-top-detail"]')).tab('show');
          // (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
          // this.getTabProfiles();
        } 
        if(from=="notif"){
          // (<any>$('.nav-tabs a[href="#conversation"]')).tab('show');
          (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
          this.getConversationAboutCustomer(this.uuid)
          // this.getTabUsers();
        }
      }, 1000);
      
    }
    this.uuid = this.route.snapshot.params['cs'];
    this.previousUrl = sessionStorage.getItem('previousUrl');
    this.retrieveCustomer(this.uuid);
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.comp=sessionStorage.getItem("comp");
    }
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  previousPage() {
    if (this.previousUrl && this.previousUrl.includes('/edit-customer/')) {
      if (this.role === 'adm' || this.role === 'asst') {
        this.router.navigate(['/customers/show', { cs: 'all' }]);
      } else if (this.role === 'cmrc') {
        this.router.navigate(['/my-customers/show', { cs: 'all' }]);
      }
      sessionStorage.removeItem('previousUrl');
    } else {
      this.location.back();
    }
  }

  // In your component.ts file
  hasServices(): boolean {
    // Check if selectedCustomer exists and has at least one service
    return (
      this.selectedCustomer &&
      this.selectedCustomer.customer_sites &&
      this.selectedCustomer.customer_sites.length > 0 &&
      this.selectedCustomer.customer_sites.some(
        (site: any) =>
          site.customerService && site.customerService.length > 0
      )
    );
  }

  checkAddress(address: string): string {
    if (address !== null && address !== undefined && address.trim() !== '') {
      return address.trim();
    } else {
      return '----';
    }
  } 
  checkServices(customerService: any): string {
    if (customerService !== null && customerService !== undefined && customerService.length > 0) {
      return customerService[0].service_name.trim();
    } else {
      return '----';
    }
  }

  // back(){
  //   // this.location.back();
  //   if(role=="cmrc") window.location.href ='/mydash';
  //    if(role=="adm") window.location.href ='/dashboard';
  // }

  selectedCustomer:any=null;
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  retrieveCustomer(customer:any){
    this.retrieveCustomerLoder = true;
    this.selectedCustomer = null;
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(customer).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;
          this.msSector.getSector(this.token,this.selectedCustomer.sector).subscribe(
            (sectorLabel: any) => {
              this.selectedCustomer.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.loading_tab_details=false;
          this.hasServices();
           // Check if the customer has a logo
           if (this.selectedCustomer.customer_logo) {
            // Convert the base64 logo to a data URL
            const logoDataUrl = 'data:image/*;base64,' + this.selectedCustomer.customer_logo;
            const imageDiv = document.getElementById('logo');
            if (imageDiv) {
              // Create an <img> element and set its src attribute
              const imgElement = document.createElement('img');
              imgElement.src = logoDataUrl;
              imgElement.alt = 'Customer Logo';
              imgElement.style.marginRight= "9px";
              imgElement.style.marginBottom= "20px";
              imgElement.style.width = '65px';
              imgElement.style.height = '65px';
              imgElement.style.borderRadius= "50%";
              imgElement.style.border = 'solid 5px #bad0c9';
              imageDiv.innerHTML = '';
              imageDiv.appendChild(imgElement);
            }
          }
        }
        this.retrieveCustomerLoder = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;

        
      }
    );
    //this.getConversationAboutCustomer(customer);
  }
  loadingMessages:boolean=false;
  messages:any[]=[];
  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {        
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          //$(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)

          setTimeout(() => {  
            $(".chat-messages")[0]?.animate({ scrollBottom: "320px" }, 200)
            var objDiv = $(".chat-messages")[0];
            objDiv.scrollTop = objDiv?.scrollHeight;
           }, 1000); 
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0]?.scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
          }
          this.loadingMessages=false;
          this.sending = false;
        },
        error => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  customerArchiveRequest:any={};
  loadingArchiveCustomer:boolean=false;
  archiveCustomer(){
    this.loadingArchiveCustomer = true;
    this.customersService.archiveCustomer(this.uuid);
    this.customerArchiveRequest=this.customersService.archiveCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="e5b99f09c7461ee9de1537ddcfd1c638"){
          this.loadingArchiveCustomer = false;
          this.selectedCustomer.archived=true;
          this.selectedCustomer.archivedBy = data.archivedBy;
          this.selectedCustomer.archivedAt = data.archivedAt;
          $("#customer_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_archived").hide();
          }, 8000);
        }else if(data.code=="587df0508983999872819f4041aef551"){
          this.loadingArchiveCustomer = false;
          $("#customer_not_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_not_archived").show();
          }, 8000);
        }else {
          this.loadingArchiveCustomer = false;
          $("#customer_not_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_not_archived").hide();
          }, 8000);
        }
        window.scroll({ 
          top: 0, 
          left: 0, 
          behavior: 'smooth' 
        });
      },
    )
  }
}
